/**
 * Maps route pathnames to page keys for fallback timestamp lookup.
 * Used when a page does not provide explicit PAGE_LAST_UPDATED config.
 */
export const ROUTE_TO_PAGE_KEY = {
  '/': 'HomePage',
  '/bio': 'BioPage',
  '/bio/sport': 'SportPage',
  '/research': 'ResearchPage',
  '/projects': 'ProjectsPage',
  '/publications': 'PublicationsPage',
  '/teaching': 'TeachingPage',
  '/events': 'EventsPage',
};
